export default __webpack_public_path__ + "static/media/IMG3.d14361c7.jpg";